import React from "react";
import styles from './TextArea.module.scss'
interface TextAreaProps extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  value?: string
}
export default function TextArea(props: TextAreaProps)
{
  const count = props.value?.length || 0
  const maxLength = props.maxLength || 1000// default maximum length
  return <div className={styles.container}>
    <textarea {...props} maxLength={maxLength}></textarea>
    <div className={styles.counter}>{count.toLocaleString()} / {maxLength.toLocaleString()}</div>
  </div>
}
